'use client';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useState, ReactNode } from 'react';

export default function QueryProvider({ children }: { children: ReactNode }) {
  // Initialize the client once per session to prevent caching issues across renders
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 1000 * 60 * 5, // 5 minutes (adjust based on app needs)
            gcTime: 1000 * 60 * 10, // 10 minutes cache cleanup
            retry: 1, // Retry failed requests once
            refetchOnWindowFocus: false, // Prevents excessive API calls in SPA
          },
        },
      })
  );

  return (
    <QueryClientProvider client={queryClient}>
      {children}
    </QueryClientProvider>
  );
}
